<template>
<div>
<ContentOverlay ></ContentOverlay>
<div class="content_card" v-if="item">





<div class="grid">
<div class="col-12 md:col-2">
<div class="content_card_content sticky_panel">
<h4 class=" text-primary" v-if="$store.state.users.user">{{$store.state.users.user.name}}</h4>



<Divider />
</div>
</div>


<div class="col-12 md:col-10">
<div class="content_card_content">
<TabNavigation :tabs="tabs"></TabNavigation>

<router-view></router-view>

</div>
</div>

</div>




</div>
 </div> 
</template>

<script>
export default {

  name: 'User',

  data () {
    return {
      item:null,

    }
  },
  mounted()
  {
    
    this.getData()
    this.checkTabName(this.tabs)    
  },
  computed:{
    tabs()
    {
      let tabs = [
          {
              title: 'genel',
              icon: 'list',
              route: 'info',
          },
      ]
      if(this.$route.params.id=="profile")
      {
        return tabs
      }
      if(this.$store.state.users.user && this.$store.state.users.user.userroles.length)
      {
        for(let element of this.$store.state.users.user.userroles)
        {
          if(element.name=="supplier")
          {
             let the_obj =  {
              title:"tedarikciler",
              icon: 'globe',
              route: 'user_suppliers',
            }
             tabs.push(the_obj)             
          }
          if(element.name=="brand")
          {
             let the_obj =  {
              title:"markalar",
              icon: 'globe',
              route: 'user_brands',
            }
             tabs.push(the_obj)             
          }

          if(element.name=="auditor")
          {
             let the_obj =  {
              title:"soru_listeleri",
              icon: 'question-circle',
              route: 'questionlists',
            }
             tabs.push(the_obj)

            the_obj =  {
              title:"denetlemeler",
              icon: 'calendar',
              route: 'audit_history',
            }
            tabs.push(the_obj)

            the_obj =  {
              title:"dogrulamalar",
              icon: 'calendar',
              route: 'verification_history',
            }
            tabs.push(the_obj)
           
          }
          if(element.name=="planner")
          {
             tabs.push(
            {
              title: "planlama_markalari",
              icon: 'globe',
              route: 'brands'
           })
          }
        }
      }

      return tabs
    }
  },
  methods:{
   
    async getData()
    {
        if(this.$route.params.id=="profile")
        {
          this.item = await this.generalApiGet("user/profile")
          await this.$store.dispatch('users/setUser',this.item) 
        }
        else
        {
          this.item = await this.generalApiGet("user/"+this.$route.params.id)
          await this.$store.dispatch('users/setUser',this.item) 
        }
        
    }
  }
};
</script>

<style lang="css" scoped>
</style>